import {
  getObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { SurveyViewName, SurveyViewNameDTO } from "./surveyViewName";

export interface SurveyViewDetailsDTO {
  surveyViewName: SurveyViewNameDTO;
  isSPoCChangeGraphAllowed: boolean;
}

export class SurveyViewDetails {
  readonly isSurveyViewDetailsSurveyViewDetails: boolean = true;

  readonly surveyViewName: SurveyViewName;
  readonly isSPoCChangeGraphAllowed: boolean;


  constructor(
  surveyViewName: SurveyViewName, 
  isSPoCChangeGraphAllowed: boolean
  ) {
    this.surveyViewName = surveyViewName;
    this.isSPoCChangeGraphAllowed = isSPoCChangeGraphAllowed;
  }

  static fromDTO(dto: SurveyViewDetailsDTO): SurveyViewDetails {
    const surveyViewName = SurveyViewName.fromDTO(getObject(dto, "surveyViewName", InvalidSurveyViewDetailsSurveyViewNameError));
    const isSPoCChangeGraphAllowed = getBoolean(dto, "isSPoCChangeGraphAllowed", InvalidSurveyViewDetailsIsSPoCChangeGraphAllowedError);
    return new SurveyViewDetails(
      surveyViewName,
      isSPoCChangeGraphAllowed
    );
  }

  toDTO(): SurveyViewDetailsDTO {
    const dto: SurveyViewDetailsDTO = {
        surveyViewName: this.surveyViewName.toDTO(),
        isSPoCChangeGraphAllowed: this.isSPoCChangeGraphAllowed
    };
    return dto;
  }
  }

SurveyViewDetails.prototype.toString = function toString(): string {
  return `SurveyViewDetails(surveyViewName='${this.surveyViewName}',isSPoCChangeGraphAllowed='${this.isSPoCChangeGraphAllowed}')`;
};

export class InvalidSurveyViewDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewDetailsError";
  }
}
export class InvalidSurveyViewDetailsSurveyViewNameError extends InvalidSurveyViewDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewDetailsSurveyViewNameError";
  }
}

export class InvalidSurveyViewDetailsIsSPoCChangeGraphAllowedError extends InvalidSurveyViewDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyViewDetailsIsSPoCChangeGraphAllowedError";
  }
}
